import { OccasionalSlot, RegularSlot } from './Slots'
import { Work } from './work'

export type RateSlot = {
    start: string
    end: string
    hasRequiredStaff: boolean
    childs: ChildsSlots[]
    staffs: StaffSlots[]
    available: number
    realRate: RateType
    potentialRate: RateType
    type: RateType
}

export enum RateType {
    success = 'success',
    error = 'error',
    warning = 'warning'
}

export type ChildsSlots = {
    childId: number
    childName: string
    parentId: number | null
    occasionalSlots: OccasionalSlot[]
    regularSlots: RegularSlot[]
}

export type StaffSlots = {
    staffId: number
    staffName: string
    self: boolean
    works: Work[]
}

export type RateSlotsAndSlots = {
    rate: RateSlot[]
    availableSlots: OccasionalSlot[]
    childs: ChildsSlots[]
    staffs: StaffSlots[]
    closingDay: boolean
}

export type DateRateSlot = {
    date: Date
    start: string
    end: string
    sectionGroupId: number
    sectionGroupName: string
    rate: RateSlot[]
}
